import React, {useState} from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import {makeStyles} from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import FormControl from "@material-ui/core/FormControl";
import Paper from "@material-ui/core/Paper";
import {WithContext as ReactTags} from "react-tag-input";
import {tagDelimiters} from "../utils/utils";

const useStyles = makeStyles(theme => ({
    grow: {
        flexGrow: 1,
    },
    title: {
        display: 'none',
        [theme.breakpoints.up('sm')]: {
            display: 'block',
        },
        marginRight: 10,
    },
    textboxPaper: {
        '& .MuiInputBase-root': {
            alignItems: 'flex-start',
        },
    },
    textbox: {
        alignItems: 'flex-start',
        '& .MuiInputBase-root': {
            alignItems: 'flex-start',
        },
    },
    root: {
        '& .MuiInputBase-root': {
            height: 200,
        },
    },
    noMargin: {
        marginBottom: 0,
        minHeight: 0
    },
}));

const ChangeTagsDialog = props => {
    const classes = useStyles();
    const [tags, setTags] = useState([]);
    const [tagSuggestions] = useState([]);
    const [tagError] = useState();

    const handleTagAddition = (newTag) => {
        setTags([...tags, newTag]);
    };

    const handleTagDelete = (i) => {
        setTags(tags.filter((tag, index) => index !== i));
    };

    return (
        <div>
            <Dialog open={props.open} onClose={props.handleCancelAddTags} aria-labelledby="form-dialog-title">
                <DialogTitle id="form-dialog-title">{props.title}</DialogTitle>
                <DialogContent>
                    <Grid container className={classes.grow} spacing={2}>
                        <Grid item xs={12}>
                            <FormControl
                                className={classes.formControl}
                                margin="dense"
                                size="small"
                                fullWidth
                            >
                                <Paper>
                                    <ReactTags tags={tags}
                                               suggestions={tagSuggestions}
                                               handleDelete={handleTagDelete}
                                               handleAddition={handleTagAddition}
                                               delimiters={tagDelimiters}/>
                                </Paper>
                            </FormControl>
                        </Grid>
                    </Grid>
                    <span>{tagError}</span>
                </DialogContent>
                <DialogActions>
                    <Button
                        id={"tag-cancel"}
                        onClick={() => {
                            setTags([]);
                            props.handleCancelAddTags()
                        }}
                        color="default"
                    >
                        Cancel
                    </Button>
                    <Button
                        id={"tags-remove"}
                        disabled={tags.length === 0}
                        onClick={() => {
                            setTags([]);
                            props.handleRemoveTags(tags)
                        }}
                        color="default"
                    >
                        Remove Tags
                    </Button>
                    <Button
                        id={"tags-add"}
                        disabled={tags.length === 0}
                        onClick={() => {
                            setTags([]);
                            props.handleAddTags(tags)
                        }}
                        color="primary"
                    >
                        Add Tags
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
};

export default ChangeTagsDialog
